import { render, staticRenderFns } from "./miaopinedit.vue?vue&type=template&id=21b68f7c&scoped=true"
import script from "./miaopinedit.vue?vue&type=script&lang=js"
export * from "./miaopinedit.vue?vue&type=script&lang=js"
import style0 from "./miaopinedit.vue?vue&type=style&index=0&id=21b68f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b68f7c",
  null
  
)

export default component.exports